export default __webpack_public_path__ + "static/media/Chestplate of Fearless Souls.d6487283.jpg";